import { Grid } from 'src/design/atoms/Grid';
import { Stack } from 'src/design/atoms/Stack';
import { Title } from 'src/design/atoms/Title';
import { Checkbox } from 'src/design/atoms/Checkbox';
import React from 'react';

export const globalOptions = [
  {
    id: 'ctc',
    label: 'CTC',
  },
  {
    id: 'jobs',
    label: 'Jobs',
  },
  {
    id: 'analytics',
    label: 'Data Analytics',
  },
  {
    id: 'activity_feed',
    label: 'Activity Feed',
  },
  {
    id: 'operations',
    label: 'Operations',
  },
  {
    id: 'time',
    label: 'Time',
  },
  {
    id: 'reports',
    label: 'Reports',
  },
  {
    id: 'manhours',
    label: 'Manhours',
  },
  {
    id: 'service_work',
    label: 'Service Work',
  },
  {
    id: 'inspections',
    label: 'Inspections',
  },
];

export const ctcOptions = [
  {
    id: 'ctc_activity_feed',
    label: 'CTC Activity Feed',
  },
];

export const jobOptions = [
  {
    id: 'activity',
    label: 'Activity',
  },
  {
    id: 'emails',
    label: 'Emails',
  },
  {
    id: 'milestones',
    label: 'Milestones',
  },
  {
    id: 'meeting_minutes',
    label: 'Meeting Minutes',
  },
  {
    id: 'tracker',
    label: 'Tracker',
  },
  {
    id: 'contacts',
    label: 'Contacts',
  },
  {
    id: 'dailys',
    label: 'Dailys',
  },
  {
    id: 'work_tickets',
    label: 'Work Tickets',
  },
  {
    id: 'changes',
    label: 'Changes',
  },
  {
    id: 'timesheets',
    label: 'Timesheets',
  },
  {
    id: 'rfis',
    label: 'RFIs',
  },
  {
    id: 'documents',
    label: 'Documents',
  },
  {
    id: 'drawings',
    label: 'Drawings',
  },
  {
    id: 'progress',
    label: 'Progress',
  },
  {
    id: 'submittals',
    label: 'Submittals',
  },
  {
    id: 'transmittals',
    label: 'Transmittals',
  },
];

interface ModuleSelectorProps {
  initialSelected: string[];
  onSelectedChange: (selected: string[]) => void;
}
export const ModuleSelector: React.FC<ModuleSelectorProps> = ({
  initialSelected,
  onSelectedChange,
}) => {
  const [selected, setSelected] = React.useState<string[]>(initialSelected);

  React.useEffect(() => {
    onSelectedChange(selected);
  }, [selected]);
  const onOptionChecked = (option: string, checked: any) => {
    if (checked) {
      return setSelected((prevState) => [...prevState, option]);
    }
    setSelected((prevState) => prevState.filter((v) => v !== option));
  };
  const renderGlobalOptions = () => {
    return globalOptions.map((o) => {
      const isChecked = !!selected.find((v) => v === o.id);
      return (
        <Grid.Col span={{ base: 6, sm: 4, md: 3 }} key={o.id}>
          <Checkbox
            checked={isChecked}
            onChange={(e) => onOptionChecked(o.id, e.currentTarget.checked)}
            label={o.label}
          />
        </Grid.Col>
      );
    });
  };

  const renderCTCOptions = () => {
    return ctcOptions.map((o) => {
      const isChecked = !!selected.find((v) => v === o.id);
      return (
        <Grid.Col span={{ base: 6, sm: 4, md: 3 }} key={o.id}>
          <Checkbox
            checked={isChecked}
            onChange={(e) => onOptionChecked(o.id, e.currentTarget.checked)}
            label={o.label}
          />
        </Grid.Col>
      );
    });
  };

  const renderOptions = () => {
    return jobOptions.map((o) => {
      const isChecked = !!selected.find((v) => v === o.id);
      return (
        <Grid.Col span={{ base: 6, sm: 4, md: 3 }} key={o.id}>
          <Checkbox
            checked={isChecked}
            onChange={(e) => onOptionChecked(o.id, e.currentTarget.checked)}
            label={o.label}
          />
        </Grid.Col>
      );
    });
  };
  return (
    <Stack gap="xs">
      <Title order={4}>Global Modules</Title>
      <Grid gutter="xs">{renderGlobalOptions()}</Grid>
      <Title order={4}>CTC Modules</Title>
      <Grid gutter="xs">{renderCTCOptions()}</Grid>
      <Title order={4}>Job Modules</Title>
      <Grid gutter="xs">{renderOptions()}</Grid>
    </Stack>
  );
};
